<template>
  <div class="mt20 item-wrapper" style="position: relative">
    <div class="delete-icon" @click.stop="deleteItem">
      <!--<a>删除</a>-->
      <Icon type="ios-close-empty" size="30"></Icon>
    </div>
    <Form class="form" ref="typeUpdateData" :rules="formRules" :model="typeUpdateData" :label-width="100" :inline="true">
      <FormItem label="房型名称">
        <Input class="input-long"/>
      </FormItem>
      <br>
      <FormItem label="室">
        <Select class="select-width">
          <Option value="">请选择</Option>
          <!--<Option></Option>-->
        </Select>
      </FormItem>
      <FormItem label="厅">
        <Select class="select-width">
          <Option value="">请选择</Option>
          <!--<Option></Option>-->
        </Select>
      </FormItem>
      <FormItem label="卫">
        <Select class="select-width">
          <Option value="">请选择</Option>
          <!--<Option></Option>-->
        </Select>
      </FormItem>
      <FormItem label="房型面积">
        <Input class="input-short"/>
      </FormItem>
      <br>
      <FormItem label="项目描述">
        <Input class="textarea-width" type="textarea"/>
      </FormItem>
      <br>
      <FormItem label="备注">
        <Input class="textarea-width"/>
      </FormItem>

    </Form>


  </div>

</template>

<script>
  export default {
    name: "TypeItem",
    data(){
      return {
        formRules:{

        },
        typeUpdateData:{},
      }
    },
    methods:{
      deleteItem(){
      }
    }

  }
</script>

<style scoped>
  .item-wrapper{
    padding-left: 20px;
  }
  .form{
    border: 1px solid rgb(220,220,220);
    overflow: auto;
  }
  .delete-icon{
    float: left;
    padding:0 10px;
    font-size: 14px;
    border: 1px solid rgb(220,220,220);
  }
  .textarea-width{
    width: 400px;
  }
  .input-long {
    width: 200px;
  }

  .select-width {
    width: 100px;
  }

  .input-short {
    width: 100px;
  }

</style>
